import { useChrome } from "@/lib/guChrome";
import React from "react";
import { Phone } from "lucide-react";

export default function EmergencyButton() {
  const { g } = useChrome();
  return (
    <a
      href="tel:+919427560101"
      data-testid="emergency-call-btn"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 bg-[#E07A5F] hover:bg-[#c9664d] text-white pl-5 pr-6 py-4 rounded-full flex items-center gap-3 font-medium transition-all duration-300 hover:-translate-y-1 animate-soft-pulse"
    >
      <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
        <Phone className="w-4 h-4" />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.18em] opacity-80">{g("Emergency")}</span>
        <span className="text-sm font-semibold">{g("Call Now")}</span>
      </span>
    </a>
  );
}
